// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import CreateAlertExecuteSelectorTemplate from '@front/templates/CreateAlertExecuteSelectorTemplate.html';
import { ContainerControl } from '@front/controls/elements/ContainerControl';
import { Resources } from '@shared/localizations/Resources';
import { AlertAfterExecute, getAlertAfterExecuteKey } from '@shared/utils/Alert/AlertConstants';
import { ResourcesManager } from '@shared/commons/properties/ResourcesManager';
import { createContextMenuItemsFromEnum } from '@shared/utils/ContextMenuUtils';
export class CreateAlertExecuteSelector extends ContainerControl {
    constructor() {
        super();
    }
    getType() {
        return 'CreateAlertExecuteSelector';
    }
    oninit() {
        super.oninit();
        this.repopulate();
        this.observe('selectedItem', this.updateAlertExecute);
        this.observe('value', this.updateAlertExecuteValue);
        ResourcesManager.onLocaleChange.Subscribe(this.localize, this);
        this.localize();
    }
    updateAlertExecute(selectedItem) {
        if (!isNullOrUndefined(selectedItem)) {
            void this.set({ value: selectedItem.value });
        }
    }
    updateAlertExecuteValue(newV, oldV) {
        const items = this.get('items');
        if (!isValidArray(items)) {
            return;
        }
        for (let i = 0; i < items.length; i++) {
            if (items[i].value === newV) {
                void this.set({ selectedItem: items[i] });
                break;
            }
        }
    }
    dispose() {
        ResourcesManager.onLocaleChange.UnSubscribe(this.localize, this);
        super.dispose();
    }
    repopulate() {
        const items = this.get('items');
        const selectedItem = items.find((item) => item.value === AlertAfterExecute.REMOVE);
        void this.set({ selectedItem });
    }
    localize() {
        void this.set('label', Resources.getResource('screen.Alerts.Label.AfterExecute'));
    }
}
ContainerControl.extendWith(CreateAlertExecuteSelector, {
    template: CreateAlertExecuteSelectorTemplate,
    data: function () {
        return {
            label: '',
            instrument: null,
            items: createContextMenuItemsFromEnum(AlertAfterExecute, getAlertAfterExecuteKey),
            selectedItem: null,
            width: 198
        };
    }
});
